import * as Sentry from "@sentry/react";

import { IS_PRODUCTION } from "@/config/env";
import { ANALYTICS_PROVIDER } from "../models";
import type { AnalyticsProvider } from "../models";

const UNREPORTED_PROVIDERS: readonly AnalyticsProvider[] = [
  ANALYTICS_PROVIDER.QUORA,
];

interface AnalyticsErrorDetails {
  message: string;
  provider?: AnalyticsProvider;
  extra?: Record<string, unknown>;
}

export const handleAnalyticsError = (
  error: unknown,
  { message, provider, extra }: AnalyticsErrorDetails,
) => {
  if (!IS_PRODUCTION) {
    console.error(`${message}:`, error);
    return;
  }

  if (provider && UNREPORTED_PROVIDERS.includes(provider)) {
    return;
  }

  Sentry.captureException(error, {
    extra: {
      ...extra,
      message,
    },
    tags: {
      feature: "analytics",
      provider,
    },
  });
};
